export default {
    colors: {
        primary: '#009652',
        secondary: '#00D776',
        tertiary: '#00371F'
    },
    overrideFunction: ({ colors }) => ({
        h1BorderColor: colors.primary,
        h2BorderColor: colors.primary,
        colorLink: colors.primary,
        subNavBg: colors.secondary,
        subNavMobileBackgroundColor: colors.secondary,
        partnerOfferMain: colors.primary,
        partnerCardMainDiscountColor: colors.primary,
        howItWorkBlockBoldColor: colors.primary,
        faqLinkTextColor: colors.black,
        hrBackgroundColor: colors.primary,

        buttonBorderRadius: '5px',
        buttonMainBg: colors.secondary,
        buttonMainText: colors.tertiary,
        buttonMainBorder: colors.secondary,
        buttonMainHoverBg: colors.secondary,
        buttonMainHoverText: colors.white,
        buttonMainHoverBorder: colors.secondary,

        buttonSecondBg: colors.secondary,
        buttonSecondText: colors.tertiary,
        buttonSecondBorder: colors.secondary
    })
};



// WEBPACK FOOTER //
// ./src/style/applicationSpecific/maReducTheme.js